import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function HospitalDeleteDialog({ open = false, hospital = null, onClose, onConfirm }) {
  const handleConfirm = () => {
    onConfirm && onConfirm(hospital);
  };

  return (
    <Dialog open={!!open} onClose={onClose} disableScrollLock>
      <DialogTitle>Delete hospital</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {hospital?.name || 'this hospital'}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="error" variant="contained">Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
